import { render } from "./exchangeField.vue?vue&type=template&id=55952775&scoped=true&ts=true"
import script from "./exchangeField.vue?vue&type=script&lang=ts"
export * from "./exchangeField.vue?vue&type=script&lang=ts"

import "./exchangeField.vue?vue&type=style&index=0&id=55952775&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55952775"]])

export default __exports__